import { render } from "./FooterCont.vue?vue&type=template&id=2686fd73"
const script = {}

import "./FooterCont.vue?vue&type=style&index=0&id=2686fd73&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__